import React, { Component } from 'react'
import { RouteComponentProps } from 'react-router-dom'

import PageLayout from 'components/layout/pageLayout'
import SubNavigation from 'components/layout/subNavigation'
import Head from 'components/layout/head'

interface TermsOfUseRigipsProps extends RouteComponentProps<any> {
  authenticated: boolean
  dispatch: any
}

type TermsOfUseRigipsState = {}

class TermsOfUseRigips extends Component<TermsOfUseRigipsProps, TermsOfUseRigipsState> {
  constructor(props: TermsOfUseRigipsProps) {
    super(props)
    this.state = {}
  }

  render() {
    return (
      <PageLayout pageTitle="FAQ">
        <Head headline="Hilfe & Hinweise" subheadline="Mengenermittlung und Systemsuche - HORST" />
        <SubNavigation
          items={[
            {
              label: 'Bedienung',
              link: '/help/manual',
            },
            {
              label: 'Nutzungsbedingungen',
              link: '/help/terms-of-use',
            },
            {
              label: 'Links',
              link: '/help/links',
            },
            {
              label: 'Impressum',
              link: 'https://www.rigips.at/impressum',
            },
          ]}
        />
        <div className="px-48 mb-65">
          <p className="font-400 text-black text-15 tracking-0.1 leading-22">
            <b className="block mb-10">
              Mengenermittlung und Systemsuche – HORST Nutzungsbedingungen
            </b>
            Mit Absenden Ihrer Anmeldung erteilen Sie den österreichischen Saint-Gobain Firmen
            (Saint-Gobain Rigips Austria GesmbH, Saint-Gobain ISOVER Austria GmbH und Saint-Gobain
            Weber Terranova GmbH) Ihre Einwilligung, Ihre personenbezogenen Daten zu eigenen
            Informationszwecken zu nutzen. Hierzu gehören z. B. die Zusendung von Informationen über
            Produkte, Anwendungen, Arbeitshilfen oder Veranstaltungen sowie Kontaktaufnahme durch
            unseren Außendienst, wobei diese Maßnahmen sowohl auf elektronischem Weg (per eMail),
            telefonisch oder in Form von Printmedien erfolgen können. Eine Weitergabe an Dritte
            erfolgt an den Serverbetreiber zur Speicherung der Daten.
          </p>
          <br />
          <p className="font-400 text-black text-15 tracking-0.1 leading-22">
            Ihr Einverständnis mit der vorstehend beschriebenen Datennutzung können Sie jederzeit
            schriftlich (Saint-Gobain Rigips Austria GesmbH, Unterkainisch 24, 8990 Bad Aussee) oder
            per eMail an{' '}
            <a className="link text-15" href="mailto:rigips.austria@saint-gobain.com">
              rigips.austria(at)saint-gobain.com
            </a>{' '}
            widerrufen. Ergänzend gelten die "Nutzungsbedingungen für die Internet-Seite{' '}
            <a
              className="link text-15"
              target="_blank"
              rel="noopener noreferrer"
              href="https://www.rigips.at"
            >
              www.rigips.at
            </a>
            ".
          </p>
          <br />
          <p className="font-400 text-black text-15 tracking-0.1 leading-22">
            Unser Dienstleister (Serverbetreiber) für den Service Mengenermittlung und Systemsuche –
            HORST ist die Firma ib-data GmbH, Softwareentwicklung für Architektur und Bauwesen,
            Hasnerstraße 118, A-1160 Wien. Die österreichischen Saint-Gobain Firmen (Saint-Gobain
            Rigips Austria GesmbH, Saint-Gobain ISOVER Austria GmbH und Saint-Gobain Weber Terranova
            GmbH) unternehmen alle zumutbaren Schritte, um die Aktualität, Richtigkeit, Wahrheit und
            Vollständigkeit der präsentierten Informationen zum Zeitpunkt der Veröffentlichung auf
            dieser Website sicherzustellen. Sie übernehmen jedoch keine Gewähr für die von ihnen
            veröffentlichten Informationen, Inhalte, Dienstleistungen, Angebote oder Produkte. Bei
            den angegebenen Preisen handelt es sich um Richtpreise. Preisänderungen werden
            vorbehalten.
          </p>
          <br />
          <p className="font-400 text-black text-15 tracking-0.1 leading-22">
            Die österreichischen Saint-Gobain Firmen (Saint-Gobain Rigips Austria GesmbH,
            Saint-Gobain ISOVER Austria GmbH und Saint-Gobain Weber Terranova GmbH) übernehmen keine
            Haftung für irgendwelche direkten oder indirekten Schäden oder Folgeschäden, die im
            Zusammenhang mit der Benutzung der Website oder der Benutzung des Mengenermittlungstools
            HORST bei Benutzern oder Dritten entstehen könnten. Die österreichischen Saint-Gobain
            Firmen (Saint-Gobain Rigips Austria GesmbH, Saint-Gobain ISOVER Austria GmbH und
            Saint-Gobain Weber Terranova GmbH) übernehmen ausserdem keine Verantwortung und geben
            keine Gewähr dafür, dass die Funktionen auf dieser Website nicht unterbrochen werden,
            fehlerlos oder frei von schädlichen Bestandteilen (z.B. Viren) sind.
          </p>
          <br />
          <p className="font-400 text-black text-15 tracking-0.1 leading-22">
            Unter bestimmten Umständen kann es entweder für die österreichischen Saint-Gobain Firmen
            erforderlich sein, die Website oder der Benutzung des Mengenermittlungstools HORST
            teilweise oder vollständig einzustellen, diese Nutzungsbedingungen aufzulösen, Ihr
            Benutzerkonto oder Ihre Zugriffsrechte zu sperren oder Sie als Benutzer auszuschließen.
            Es kann unter diesen Umständen vorkommen, dass Sie nicht auf Ihr Benutzerkonto oder Ihre
            Einstellungen zugreifen können. Wir behalten uns das Recht vor, unsere Dienste jederzeit
            auszusetzen oder einzustellen, mit oder ohne Grund und mit oder ohne Ankündigung.{' '}
          </p>
          <br />
        </div>
      </PageLayout>
    )
  }
}

export default TermsOfUseRigips
